import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const NavBar: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    if (window.confirm("ログアウトしますか？")) {
      logout();
      navigate("/login");
    }
  };

  return (
    <header className="bg-white border-b border-gray-200 py-4 shadow-sm hidden md:block">
      <div className="max-w-7xl mx-auto px-8 flex justify-between items-center flex-col md:flex-row gap-4 md:gap-0 text-center md:text-left">
        <div className="flex items-center gap-4">
          <Link to="/dashboard" className="no-underline">
            <h1 className="m-0 text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-br from-indigo-500 to-purple-600">
              就活ダッシュボード
            </h1>
            <p className="m-0 text-xs text-gray-500">
              就活企業とスケジュールを管理
            </p>
          </Link>

          <nav aria-label="Main navigation">
            <ul className="list-none m-0 p-0 flex gap-3">
              <li>
                <Link
                  to="/dashboard"
                  className="text-gray-700 no-underline py-1.5 px-2 rounded-md hover:bg-gray-100 transition-colors"
                >
                  ダッシュボード
                </Link>
              </li>
              <li>
                <Link
                  to="/companies"
                  className="text-gray-700 no-underline py-1.5 px-2 rounded-md hover:bg-gray-100 transition-colors"
                >
                  企業
                </Link>
              </li>
              <li>
                <Link
                  to="/es-templates"
                  className="text-gray-700 no-underline py-1.5 px-2 rounded-md hover:bg-gray-100 transition-colors"
                >
                  ESテンプレート
                </Link>
              </li>
              <li>
                <Link
                  to="/schedules"
                  className="text-gray-700 no-underline py-1.5 px-2 rounded-md hover:bg-gray-100 transition-colors"
                >
                  スケジュール
                </Link>
              </li>
              {user?.role === "admin" && (
                <li>
                  <Link
                    to="/admin"
                    className="text-white bg-purple-600 no-underline py-1.5 px-2 rounded-md hover:bg-purple-700 transition-colors font-medium"
                  >
                    管理者
                  </Link>
                </li>
              )}
            </ul>
          </nav>
        </div>

        <div className="flex items-center gap-4 justify-center md:justify-start">
          <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-gray-200">
            {user?.picture ? (
              <img
                src={user.picture}
                alt="プロフィール"
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-semibold text-lg">
                {user?.username?.charAt(0).toUpperCase() || "U"}
              </div>
            )}
          </div>

          <div className="flex flex-col">
            <span className="text-sm text-gray-600">{user?.email || ""}</span>
          </div>

          <button
            onClick={handleLogout}
            className="py-2 px-4 bg-red-600 text-white border-none rounded-md text-sm cursor-pointer transition-colors hover:bg-red-700"
          >
            ログアウト
          </button>
        </div>
      </div>
    </header>
  );
};

export default NavBar;
